/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemBoundaryEntity } from './SystemBoundaryEntity';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityFromJSONTyped,
    SystemBoundaryEntityToJSON,
    SystemBoundaryEntityToJSONTyped,
} from './SystemBoundaryEntity';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    picture?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    preferredUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    identityProvider?: UserIdentityProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    providerUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    status?: UserStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    ssoLinkedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    deletedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastLogin?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastPasswordChange?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    profileUpdatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    preferredTimezone?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    timezoneUpdatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    updatedAt?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof User
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof User
     */
    externalIdentityMappings?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof User
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {any}
     * @memberof User
     */
    systemBoundary?: any | null;
    /**
     * 
     * @type {Set<SystemBoundaryEntity>}
     * @memberof User
     */
    additionalBoundaries?: Set<SystemBoundaryEntity>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof User
     */
    boundaryAccessSources?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    deleted?: boolean;
}


/**
 * @export
 */
export const UserIdentityProviderEnum = {
    Keycloak: 'KEYCLOAK',
    AzureAd: 'AZURE_AD',
    Okta: 'OKTA',
    Google: 'GOOGLE',
    Custom: 'CUSTOM',
    Integration: 'INTEGRATION'
} as const;
export type UserIdentityProviderEnum = typeof UserIdentityProviderEnum[keyof typeof UserIdentityProviderEnum];

/**
 * @export
 */
export const UserStatusEnum = {
    SsoLinked: 'SSO_LINKED',
    Active: 'ACTIVE'
} as const;
export type UserStatusEnum = typeof UserStatusEnum[keyof typeof UserStatusEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'givenName': json['givenName'] == null ? undefined : json['givenName'],
        'familyName': json['familyName'] == null ? undefined : json['familyName'],
        'picture': json['picture'] == null ? undefined : json['picture'],
        'preferredUsername': json['preferredUsername'] == null ? undefined : json['preferredUsername'],
        'identityProvider': json['identityProvider'] == null ? undefined : json['identityProvider'],
        'providerUserId': json['providerUserId'] == null ? undefined : json['providerUserId'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'ssoLinkedAt': json['ssoLinkedAt'] == null ? undefined : (new Date(json['ssoLinkedAt'])),
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
        'lastLogin': json['lastLogin'] == null ? undefined : (new Date(json['lastLogin'])),
        'lastPasswordChange': json['lastPasswordChange'] == null ? undefined : (new Date(json['lastPasswordChange'])),
        'profileUpdatedAt': json['profileUpdatedAt'] == null ? undefined : (new Date(json['profileUpdatedAt'])),
        'preferredTimezone': json['preferredTimezone'] == null ? undefined : json['preferredTimezone'],
        'timezoneUpdatedAt': json['timezoneUpdatedAt'] == null ? undefined : (new Date(json['timezoneUpdatedAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'externalIdentityMappings': json['externalIdentityMappings'] == null ? undefined : json['externalIdentityMappings'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'systemBoundary': json['systemBoundary'] == null ? undefined : json['systemBoundary'],
        'additionalBoundaries': json['additionalBoundaries'] == null ? undefined : (new Set((json['additionalBoundaries'] as Array<any>).map(SystemBoundaryEntityFromJSON))),
        'boundaryAccessSources': json['boundaryAccessSources'] == null ? undefined : json['boundaryAccessSources'],
        'active': json['active'] == null ? undefined : json['active'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
        'givenName': value['givenName'],
        'familyName': value['familyName'],
        'picture': value['picture'],
        'preferredUsername': value['preferredUsername'],
        'identityProvider': value['identityProvider'],
        'providerUserId': value['providerUserId'],
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'ssoLinkedAt': value['ssoLinkedAt'] == null ? undefined : ((value['ssoLinkedAt']).toISOString()),
        'deletedAt': value['deletedAt'] == null ? undefined : ((value['deletedAt']).toISOString()),
        'lastLogin': value['lastLogin'] == null ? undefined : ((value['lastLogin']).toISOString()),
        'lastPasswordChange': value['lastPasswordChange'] == null ? undefined : ((value['lastPasswordChange']).toISOString()),
        'profileUpdatedAt': value['profileUpdatedAt'] == null ? undefined : ((value['profileUpdatedAt']).toISOString()),
        'preferredTimezone': value['preferredTimezone'],
        'timezoneUpdatedAt': value['timezoneUpdatedAt'] == null ? undefined : ((value['timezoneUpdatedAt']).toISOString()),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'metadata': value['metadata'],
        'externalIdentityMappings': value['externalIdentityMappings'],
        'goldenRecordId': value['goldenRecordId'],
        'systemBoundary': value['systemBoundary'],
        'additionalBoundaries': value['additionalBoundaries'] == null ? undefined : (Array.from(value['additionalBoundaries'] as Set<any>).map(SystemBoundaryEntityToJSON)),
        'boundaryAccessSources': value['boundaryAccessSources'],
        'active': value['active'],
        'deleted': value['deleted'],
    };
}

